function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { injectIntl } from 'react-intl';
import isObjectLike from 'lodash/isObjectLike';
import GoToArrow from 'components/GoToArrow';
import Link from 'components/Link';
import intlShape from 'shapes/intlShape';
var _React_PureComponent;
class LinkTile extends (_React_PureComponent = React.PureComponent) {
    onClick(evt) {
        if (!this.props.to || this.props.onClick) {
            evt.preventDefault();
        }
        if (!this.props.onClick || this.props.isDisabled) {
            return;
        }
        this.props.onClick();
    }
    renderMessage(message) {
        if (!message) {
            return null;
        }
        if (isObjectLike(message) && !/*#__PURE__*/ React.isValidElement(message)) {
            return this.props.intl.formatMessage(message, _object_spread({}, message.values));
        }
        return message;
    }
    renderHeader() {
        const header = this.renderMessage(this.props.labelMessage);
        if (!header) {
            return null;
        }
        return /*#__PURE__*/ _jsx("h3", {
            className: "linkTile__header",
            children: header
        });
    }
    renderInfo() {
        const info = this.renderMessage(this.props.infoMessage);
        if (!info) {
            return null;
        }
        return /*#__PURE__*/ _jsx("p", {
            className: "linkTile__info",
            children: info
        });
    }
    renderContent() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.renderHeader(),
                this.renderInfo()
            ]
        });
    }
    renderImage() {
        if (!this.props.image) return null;
        return /*#__PURE__*/ _jsx("div", {
            className: "col-auto",
            children: /*#__PURE__*/ _jsx("figure", {
                className: cn('linkTile__image', {
                    'linkTile__image--border': this.props.hasImageBorder
                }),
                children: this.props.image
            })
        });
    }
    renderArrow() {
        if (!this.props.to && !this.props.onClick) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "col-auto",
            children: /*#__PURE__*/ _jsx(GoToArrow, {})
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(Link, {
            to: this.props.to,
            className: cn('linkTile', this.props.className, {
                'linkTile--border': this.props.hasBorder,
                'linkTile--disabled': this.props.isDisabled,
                'linkTile--noAction': !this.props.to && !this.props.onClick
            }),
            onClick: (evt)=>this.onClick(evt),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row align-items-center",
                children: [
                    this.renderImage(),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col",
                        children: this.renderContent()
                    }),
                    this.renderArrow()
                ]
            })
        });
    }
}
_define_property(LinkTile, "propTypes", {
    // Explicit props
    to: PropTypes.string,
    labelMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element
    ]).isRequired,
    infoMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element
    ]),
    image: PropTypes.node,
    isDisabled: PropTypes.bool,
    hasBorder: PropTypes.bool,
    hasImageBorder: PropTypes.bool,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    // Explicit actions
    onClick: PropTypes.func,
    // Implicit props
    intl: intlShape.isRequired
});
_define_property(LinkTile, "defaultProps", {
    to: '',
    isDisabled: false,
    hasBorder: false,
    className: ''
});
export default injectIntl(LinkTile);
